import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  TextField,
  Typography,
  Divider,
  Link,
  Container,
} from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import MicrosoftIcon from "@mui/icons-material/Microsoft";
import AppleIcon from "@mui/icons-material/Apple";

const Login: React.FC = () => {
  const [email, setEmail] = useState("test@test.com");
  const navigate = useNavigate();

  const handleContinue = () => {
    // Add any validation logic here
    navigate("/chat");
  };

  return (
    <Container maxWidth="xs">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{ py: 4 }}
      >
        <img
          src="logo.png"
          alt="Logo"
          width={70}
          style={{ marginBottom: 80 }}
        />
        <Typography variant="h4" gutterBottom>
          Welcome back
        </Typography>
        <TextField
          label="Email address"
          variant="outlined"
          fullWidth
          required
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button
          variant="contained"
          color="success"
          fullWidth
          onClick={handleContinue}
          sx={{
            mt: 2,
            mb: 3,
            textTransform: "none",
            height: 50,
          }}
        >
          Continue
        </Button>
        <Typography variant="body2" gutterBottom>
          Don't have an account? <Link href="/signup">Sign Up</Link>
        </Typography>
        <Divider sx={{ width: "100%", my: 3 }}>OR</Divider>
        {["Google", "Microsoft Account", "Apple"].map((provider) => (
          <Button
            key={provider}
            variant="outlined"
            startIcon={
              provider === "Google" ? (
                <GoogleIcon />
              ) : provider === "Microsoft Account" ? (
                <MicrosoftIcon />
              ) : (
                <AppleIcon />
              )
            }
            fullWidth
            sx={{ mb: 1, height: 50 }}
          >
            Continue with {provider}
          </Button>
        ))}
        <Typography
          variant="body2"
          color="textSecondary"
          align="center"
          sx={{ mt: 10, mb: 5 }}
        >
          <Link href="/terms">Terms of Use</Link> |{" "}
          <Link href="/privacy">Privacy Policy</Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default Login;
